import { useDroppable } from '@dnd-kit/core';
import React from 'react';
import { Link } from 'react-router-dom';

const CalendarPickupEvent = ({ pickup, START_HOUR }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `calendar-pickup-${pickup.id}`,

    data: {
      pickup,
    },
  });

  return (
    <Link
      to={`/pickups/${pickup.id}`}
      ref={setNodeRef}
      className="shadow-sm text-decoration-none"
      style={{
        marginBottom: '4px',
        display: 'block',

        background: '#0d6efd',
        color: '#fff',
        borderRadius: '12px',
        padding: '10px',
        zIndex: 5,
        cursor: 'pointer',

        boxShadow: isOver ? '0 0 0 2px #fff' : '',

        transition: '0.2s ease',
      }}
    >
      <div className="fw-bold small">Delivery #{pickup.id}</div>
      <div className="small mt-1">{pickup.driver?.name || 'Unassigned'}</div>
    </Link>
  );
};

export default CalendarPickupEvent;
